import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const startSummaryTask = async (trialId) => {
  const token = localStorage.getItem("token");
  const response = await axios.post(
    `${__API_URL__}/api/photos/trials/${trialId}/ecrf-discrepancy-summary/`,
    {},
    { headers: { Authorization: `Token ${token}` } }
  );
  return response.data;
};

const fetchSummaryStatus = async (trialId, taskId) => {
  const token = localStorage.getItem("token");
  const response = await axios.get(
    `${__API_URL__}/api/photos/trials/${trialId}/ecrf-discrepancy-summary/status/`,
    {
      params: { task_id: taskId },
      headers: { Authorization: `Token ${token}` },
    }
  );
  return response.data;
};

// Kicks off the backend discrepancy-summary task (deduped server-side per trial) and polls
// its status until it settles. Returns the per-site summaries keyed by investigator id.
const useGetEcrfDiscrepancySummary = ({ trialId, enabled = true }) => {
  const startQuery = useQuery({
    queryKey: ["ecrf_discrepancy_summary_task", trialId],
    queryFn: () => startSummaryTask(trialId),
    enabled: enabled && Boolean(trialId),
    staleTime: Infinity,
  });

  const taskId = startQuery.data?.task_id;

  const statusQuery = useQuery({
    queryKey: ["ecrf_discrepancy_summary_status", trialId, taskId],
    queryFn: () => fetchSummaryStatus(trialId, taskId),
    enabled: Boolean(trialId) && Boolean(taskId),
    refetchInterval: (query) => {
      const state = query.state.data?.state;
      if (state === "SUCCESS" || state === "FAILURE") return false;
      return 3000;
    },
  });

  const state = statusQuery.data?.state;
  const isSettled = state === "SUCCESS" || state === "FAILURE";

  return {
    sites: statusQuery.data?.sites || null,
    isLoading:
      enabled && Boolean(trialId) && !isSettled && !startQuery.isError && !statusQuery.isError,
    isError: state === "FAILURE" || startQuery.isError || statusQuery.isError,
  };
};

export default useGetEcrfDiscrepancySummary;
